import { Link } from 'react-router-dom'
import { useAuthState } from '@percent/cause-dashboard/common/hooks'
import { useTranslation } from 'react-i18next'
import styles from './NavigationBar.module.scss'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { SET_LOGOUT } from '@percent/cause-dashboard/context/auth'
import { useAuthDispatch } from '@percent/cause-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'
import { useCausesPortalAnalytics } from '@percent/cause-dashboard/common/hooks'
import { HELP_LINK } from '@percent/cause-dashboard/constants/support'
import { Logo, Box } from '@percent/lemonade'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { GOODSTACK_WEBSITE } from '@percent/cause-dashboard/constants/general'
import { LocalePicker } from '../localePicker'

export function NavigationBar() {
  const {
    authState: { isAuthorised }
  } = useAuthState()
  const { t } = useTranslation()
  const { authService } = useServices()
  const { authDispatch } = useAuthDispatch()
  const { reset: resetAnalytics } = useCausesPortalAnalytics()

  const handleLogout = () => {
    authService.logout().then(() => {
      resetAnalytics()
      authDispatch({
        type: SET_LOGOUT
      })
    })
  }

  return (
    <Box className={styles.appBar}>
      <Box className={styles.appBarContent}>
        <a href={GOODSTACK_WEBSITE}>
          <Logo />
        </a>
        <div className={styles.logInOutButtonDiv}>
          <a href={HELP_LINK} className={styles.navLink}>
            {t('button.getHelp')}
          </a>
          {isAuthorised ? (
            <Link to="/" onClick={handleLogout} className={styles.navLink}>
              {t('button.logout')}
            </Link>
          ) : (
            <Link to={RoutePath.SIGNIN} className={styles.navLink}>
              {t('button.logIn')}
            </Link>
          )}
          <LocalePicker />
        </div>
      </Box>
    </Box>
  )
}
